import React, { ReactNode } from "react";
import classNames from "classnames";

interface Props {
  children: ReactNode;
  sectionTitle?: string;
  showRequire?: boolean;
  theme?: string;
  removeSectionTitle?: boolean;
  removeSectionTitleWrapper?: boolean;
  bordered?: boolean;
}

const MainFormSection: React.FC<Props> = (props: Props) => {
  const {
    children,
    sectionTitle,
    theme,
    showRequire = false,
    removeSectionTitle = false,
    removeSectionTitleWrapper = false,
    bordered = false,
  } = props;

  const responseSectionTitle = (
    <div className={classNames({ "main-form-section-no-title": removeSectionTitle, "main-form-section-title": !removeSectionTitle })}>
      {sectionTitle}
    </div>
  );

  let classes = theme;

  if (removeSectionTitleWrapper) {
    classes = "";
  }

  const borderClass = bordered ? "main-form-section-border" : "";

  return (
    <>
      <div className="row">
        <div className="col">
          <div className={`main-form-section-title-wrapper ${classes}`}>
            {responseSectionTitle}
            {showRequire && (
              <div className="main-form-show-required">
                <span>*</span>=Required Field
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className={`main-form-section ${borderClass}`}>
            <div className="check-box-content">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainFormSection;
